$(function() {

  $('.read-more-block').each(function() {

    $(this).readmore({
      speed: 300,
      moreLink: '<a href="#" class="more">Leggi di più</a>',
      lessLink: '<a href="#" class="more">Chiudi</a>'
    });

  });

});